import { r as registerInstance, h, g as getElement } from './index-16dc7dde.js';
import { c as classnames } from './index-136476ff.js';
import { d as debounce_1 } from './debounce-e28ac3ab.js';
import { q as EPromiseStatus, D as DEBOUNCED_HANDLER_DELAY } from './request.constants-deb285e0.js';
import { a as isMobile, J as setQueryParam, g as getData, K as getCategoryIdFromName, i as isEmpty, L as BUSINESS_ID_PARAM_NAME } from './utils-15ad90ec.js';
import { l as isPublicEnvironment, o as buildURL, A as ATG_CATEGORIES_BUSINESS_ID, u as useReplatformedHMC } from './lookups-705fb53e.js';
import { u as updatePageLoadData } from './send-33ade633.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import './product-card-6bb8cb81.js';
import { s as store } from './pes-router-store-1a105b49.js';
import './store-9d26336f.js';
import { i as isApc } from './comparator-188d64f5.js';
import './_commonjsHelpers-ba3f0406.js';
import './isObject-33fa1780.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './tslib.es6-2af8cb53.js';
import './_isIndex-af307327.js';
import './currency-b61904e0.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './pick-bfea8c03.js';
import './_basePickBy-9e484e47.js';
import './identity-6651b537.js';
import './isTypedArray-dfccd669.js';
import './toString-da636857.js';
import './_assignValue-8e900715.js';
import './hasIn-6ce0da41.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './pes-product-link-b5153381.js';
import './utils-e67addce.js';
import './isEmpty-b60327cb.js';
import './utils-2361a8f1.js';
import './index-634d378a.js';

const allProductsCss = ".all-products{background-color:#f7f7f7}@media screen and (max-width: 979px){.all-products{display:flex;flex-direction:column-reverse}}.all-products__main-content{position:relative}@media screen and (min-width: 980px){.all-products__main-content{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;padding-bottom:30px}.all-products__main-content--menu-opened::after{content:\"\";position:absolute;left:0;right:0;top:58px;bottom:0;background:#666666;opacity:0.7;z-index:1}}@media screen and (max-width: 979px){.all-products__header{margin:0;color:#333333;text-align:center;padding:24px 0 16px;font-size:24px;line-height:36px;font-weight:700;width:100%}}@media screen and (min-width: 980px){.all-products__header{display:none}}@media screen and (min-width: 980px){.all-products__section{display:flex;flex-wrap:wrap;width:1200px;max-width:1200px;padding:0;box-sizing:border-box}.all-products__section *,.all-products__section *::before,.all-products__section *::after{box-sizing:inherit}}.all-products__section--inactive{display:none}.all-products__section-title-wrapper{display:none}@media screen and (min-width: 980px){.all-products__section-title-wrapper{display:flex;flex-basis:100%;height:52px}}.all-products__section-title{display:inline-flex;align-items:center;padding:0 10px;font-size:22px;line-height:30px;font-weight:700;color:#333333;text-decoration:none}.all-products__section-title-icon{position:relative;top:2px}:host(:not([dir=\"rtl\"])) .all-products__section-title-icon{left:8px}:host([dir=\"rtl\"]) .all-products__section-title-icon{right:8px;transform:scaleX(-1)}@media screen and (min-width: 980px){.all-products__top-categories{display:block;width:100%}}.all-products__menu-category{display:none}@media screen and (min-width: 980px){.all-products__menu-category{position:relative;display:block;width:25%;padding:6px 10px 0}}@media screen and (min-width: 980px){.all-products__top-runners{display:flex;flex-flow:wrap;align-content:flex-start;width:75%}}";

let AllProducts = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hideDownloadCenterBanner = false;
    this.hideMasterRangesBanner = false;
    this.disableBusinessLinesHashRouting = false;
    this.isPBS = false;
    this.showBreadcrumbs = true;
    this.isMobile = isMobile();
    this.businessCategoriesMap = {};
    this.activeBusinessId = null;
    this.defaultSelectorConfig = null;
    this.menuCategoryOpened = false;
    this.changeActiveLine = (id) => {
      this.activeBusinessId = id;
    };
    this.getCountryCode = (countryCode) => {
      return isPublicEnvironment() ? countryCode.toLowerCase() : countryCode;
    };
    this.setActiveBusinessId = (businessId, sourceId) => {
      this.activeBusinessId = this.activeBusinessId === businessId ? null : businessId;
      const searchParams = new URLSearchParams(window.location.search);
      if (!this.isPBS) {
        setQueryParam(searchParams, BUSINESS_ID_PARAM_NAME, sourceId);
        window.history.replaceState(null, '', `?${searchParams.toString()}${window.location.hash}`);
      }
      updatePageLoadData({ pageCategory: sourceId });
    };
    this.getLegacyCategoriesByBusiness = async (id) => {
      var _a;
      try {
        const params = new URLSearchParams(this.categoriesUrl.split('?')[1]);
        const QueryParams = Object.fromEntries(params);
        const { brand, 'country-code': countryCode, 'language-code': languageCode } = QueryParams;
        const cultureCode = ((_a = this.atgBusinesses) === null || _a === void 0 ? void 0 : _a.length) > 0 ? this.atgBusinesses[0].id.split('_')[1] : countryCode;
        const atgcategoriesEndpoint = buildURL({
          host: null,
          contextRoot: isApc ? brand : '',
          countryCode: this.getCountryCode(countryCode),
          languageCode,
          endpoint: `${ATG_CATEGORIES_BUSINESS_ID}?business-id=${id}${languageCode}_${cultureCode}`,
        });
        const [sprykerCategoriesResponse, AtgCategoriesResponse] = await Promise.allSettled([
          getData(false, this.categoriesUrl.replace(':id', id)),
          getData(false, atgcategoriesEndpoint),
        ]);
        if (sprykerCategoriesResponse.status === EPromiseStatus.FULFILLED) {
          this.sprykerCategoriesByBusinessId = sprykerCategoriesResponse.value;
        }
        else if (sprykerCategoriesResponse.status === EPromiseStatus.REJECTED) {
          console.log('spryker get categories by business ID failed', sprykerCategoriesResponse.reason);
        }
        if (AtgCategoriesResponse.status === EPromiseStatus.FULFILLED) {
          this.atgCategoriesByBusinessId = AtgCategoriesResponse.value;
        }
        else if (AtgCategoriesResponse.status === EPromiseStatus.REJECTED) {
          console.log('Atg get categories by business ID failed', AtgCategoriesResponse.reason);
        }
      }
      catch (error) {
        console.log('Unexpected error:', error);
      }
    };
    this.getLegacyCategoriesByBusinessIdWithHmc = async (id) => {
      var _a;
      await this.getLegacyCategoriesByBusiness(id);
      if (!this.sprykerCategoriesByBusinessId && !this.atgCategoriesByBusinessId)
        return [];
      return (_a = this.sprykerCategoriesByBusinessId) === null || _a === void 0 ? void 0 : _a.map((category) => {
        var _a;
        const categoryObj = (_a = this.atgCategoriesByBusinessId) === null || _a === void 0 ? void 0 : _a.find((atgCategory) => getCategoryIdFromName(atgCategory.id) === category.id);
        if (categoryObj) {
          return Object.assign(Object.assign({}, category), { hmcBanner: categoryObj.hmcBanner });
        }
        return category;
      });
    };
    this.requestCategoriesByBusinessId = (id) => {
      if (this.categoriesUrl) {
        return useReplatformedHMC()
          ? this.getReplatformedCategoriesByBusinessIdWithHmc(id)
          : this.getLegacyCategoriesByBusinessIdWithHmc(id);
      }
      return this.getCategoriesByBusinessId(id);
    };
    this.getReplatformedCategoriesByBusiness = async (id) => {
      try {
        const params = new URLSearchParams(this.categoriesUrl.split('?')[1]);
        const QueryParams = Object.fromEntries(params);
        const { 'country-code': countryCode, 'language-code': languageCode } = QueryParams;
        this.categoriesByBusinessId = await getData(false, this.categoriesUrl.replace(':id', id));
        const pimIds = this.categoriesByBusinessId.map((category) => category.id).join();
        const hmcCategoriesUrl = `/visibility/${this.getCountryCode(countryCode)}/${languageCode}/category_page?pimIds=${pimIds}&hmcBanner=${true}`;
        this.categoriesListWithHMC = await getData(false, hmcCategoriesUrl);
      }
      catch (error) {
        console.log('Error:', error);
      }
    };
    this.getReplatformedCategoriesByBusinessIdWithHmc = async (id) => {
      var _a;
      await this.getReplatformedCategoriesByBusiness(id);
      if (!this.categoriesByBusinessId && !this.categoriesListWithHMC)
        return [];
      const CategorieswithHMC = {};
      this.categoriesListWithHMC.forEach((hmcCategory) => {
        const { pimId, hmcBanner } = hmcCategory;
        if (hmcBanner)
          CategorieswithHMC[pimId] = hmcBanner;
      });
      return (_a = this.categoriesByBusinessId) === null || _a === void 0 ? void 0 : _a.map((category) => {
        const hmcBanner = CategorieswithHMC[category.id];
        if (hmcBanner) {
          return Object.assign(Object.assign({}, category), { hmcBanner });
        }
        return category;
      });
    };
    this.requestProductSelectorConfig = () => {
      if (this.selectorConfigUrl) {
        return getData(false, this.selectorConfigUrl);
      }
      return this.getProductSelectorConfig();
    };
    this.setBusinessCategoriesMap = (id, businessCategory) => {
      this.businessCategoriesMap = Object.assign(Object.assign({}, this.businessCategoriesMap), { [id]: businessCategory });
    };
    this.getActiveBusiness = (businessId) => {
      var _a;
      return (_a = this.businesses) === null || _a === void 0 ? void 0 : _a.find((business) => (business === null || business === void 0 ? void 0 : business.id) === businessId);
    };
    this.resizeWindow = () => {
      this.isMobile = isMobile();
    };
    this.debouncedHandleResize = debounce_1(this.resizeWindow, DEBOUNCED_HANDLER_DELAY);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleMenuCategoryOpen() {
    this.menuCategoryOpened = true;
  }
  handleMenuCategoryClose() {
    this.menuCategoryOpened = false;
  }
  activeBusinessIdWatcher(id) {
    this.fetchCategoriesByBusinessId(id);
  }
  fetchCategoriesByBusinessId(id) {
    if (!id || id in this.businessCategoriesMap) {
      return;
    }
    this.requestCategoriesByBusinessId(id).then((res) => {
      this.setBusinessCategoriesMap(id, res);
    });
  }
  requestCommerceConnectorSettings() {
    if (this.commerceConnectorUrl) {
      return getData(false, this.commerceConnectorUrl);
    }
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    this.businesses = (_a = tryParse(this._businesses)) !== null && _a !== void 0 ? _a : this.businesses;
    this.topCategories = (_b = tryParse(this._topCategories)) !== null && _b !== void 0 ? _b : this.topCategories;
    this.appActionBlocks = (_c = tryParse(this._appActionBlocks)) !== null && _c !== void 0 ? _c : this.appActionBlocks;
    this.appLearnMoreLabel = (_d = tryParse(this._appLearnMoreLabel)) !== null && _d !== void 0 ? _d : this.appLearnMoreLabel;
    this.appHmcLabel = (_e = tryParse(this._appHmcLabel)) !== null && _e !== void 0 ? _e : this.appHmcLabel;
    this.appMostViewedProductsLabel = (_f = tryParse(this._appMostViewedProductsLabel)) !== null && _f !== void 0 ? _f : this.appMostViewedProductsLabel;
    this.appProductsForYouLabel = (_g = tryParse(this._appProductsForYouLabel)) !== null && _g !== void 0 ? _g : this.appProductsForYouLabel;
    this.appProductsLabel = (_h = tryParse(this._appProductsLabel)) !== null && _h !== void 0 ? _h : this.appProductsLabel;
    this.appRangesLabel = (_j = tryParse(this._appRangesLabel)) !== null && _j !== void 0 ? _j : this.appRangesLabel;
    this.appTopRangesForLabel = (_k = tryParse(this._appTopRangesForLabel)) !== null && _k !== void 0 ? _k : this.appTopRangesForLabel;
    this.appTopTangesLabel = (_l = tryParse(this._appTopTangesLabel)) !== null && _l !== void 0 ? _l : this.appTopTangesLabel;
    this.appToprunnerTypeNewLabel = (_m = tryParse(this._appToprunnerTypeNewLabel)) !== null && _m !== void 0 ? _m : this.appToprunnerTypeNewLabel;
    this.appToprunnerTypePromotedLabel = (_o = tryParse(this._appToprunnerTypePromotedLabel)) !== null && _o !== void 0 ? _o : this.appToprunnerTypePromotedLabel;
    this.appViewProductListLink = (_p = tryParse(this._appViewProductListLink)) !== null && _p !== void 0 ? _p : this.appViewProductListLink;
    this.breadCrumbsAllProductsLabel = (_q = tryParse(this._breadCrumbsAllProductsLabel)) !== null && _q !== void 0 ? _q : this.breadCrumbsAllProductsLabel;
    this.hmcToolsLink = (_r = tryParse(this._hmcToolsLink)) !== null && _r !== void 0 ? _r : this.hmcToolsLink;
    this.productRelationsViewProdLabel = (_s = tryParse(this._productRelationsViewProdLabel)) !== null && _s !== void 0 ? _s : this.productRelationsViewProdLabel;
    this.prpPriceLabel = (_t = tryParse(this._prpPriceLabel)) !== null && _t !== void 0 ? _t : this.prpPriceLabel;
    this.prpTopcategoryLabel = (_u = tryParse(this._prpTopcategoryLabel)) !== null && _u !== void 0 ? _u : this.prpTopcategoryLabel;
    this.seeAllOffersLink = (_v = tryParse(this._seeAllOffersLink)) !== null && _v !== void 0 ? _v : this.seeAllOffersLink;
    this.viewOnLabel = (_w = tryParse(this._viewOnLabel)) !== null && _w !== void 0 ? _w : this.viewOnLabel;
    this.hideDownloadCenterBanner = (_x = tryParse(this._hideDownloadCenterBanner)) !== null && _x !== void 0 ? _x : this.hideDownloadCenterBanner;
    this.hideMasterRangesBanner = (_y = tryParse(this._hideMasterRangesBanner)) !== null && _y !== void 0 ? _y : this.hideMasterRangesBanner;
    this.categoriesUrl = (_z = tryParse(this._categoriesUrl)) !== null && _z !== void 0 ? _z : this.categoriesUrl;
    this.selectorConfigUrl = (_0 = tryParse(this._selectorConfigUrl)) !== null && _0 !== void 0 ? _0 : this.selectorConfigUrl;
    this.commerceConnectorUrl = (_1 = tryParse(this._commerceConnectorUrl)) !== null && _1 !== void 0 ? _1 : this.commerceConnectorUrl;
    this.disableBusinessLinesHashRouting = (_2 = tryParse(this._disableBusinessLinesHashRouting)) !== null && _2 !== void 0 ? _2 : this.disableBusinessLinesHashRouting;
    this.getCategoriesByBusinessId = (_3 = tryParse(this._getCategoriesByBusinessId)) !== null && _3 !== void 0 ? _3 : this.getCategoriesByBusinessId;
    this.getProductSelectorConfig = (_4 = tryParse(this._getProductSelectorConfig)) !== null && _4 !== void 0 ? _4 : this.getProductSelectorConfig;
    (_5 = this.requestProductSelectorConfig()) === null || _5 === void 0 ? void 0 : _5.then((res) => {
      this.defaultSelectorConfig = res;
    });
    (_6 = this.requestCommerceConnectorSettings()) === null || _6 === void 0 ? void 0 : _6.then((res) => {
      this.commerceConnectorSettings = res;
    });
    if (this.isPBS) {
      store.set('enableAppRouting', true);
    }
  }
  connectedCallback() {
    window.addEventListener('resize', this.debouncedHandleResize);
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
  hasActionBlocks() {
    return this.appActionBlocks && !isEmpty(this.appActionBlocks);
  }
  renderTitle(currentBusiness) {
    if (this.isPBS) {
      return h("span", { class: "all-products__section-title" }, currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.name);
    }
    return (h("a", { href: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.url, class: "all-products__section-title" }, h("span", { class: "all-products__section-title-text" }, currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.name), h("pes-icon", { class: "all-products__section-title-icon", size: pesIconSizes.MICRO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
  }
  render() {
    var _a, _b, _c, _d, _e;
    const activeLine = this.getActiveBusiness(this.activeBusinessId);
    const businessCategories = (_a = this.businessCategoriesMap[this.activeBusinessId]) !== null && _a !== void 0 ? _a : [];
    const isTopCategoriesActive = !this.activeBusinessId || this.isMobile;
    return (h("div", { class: "all-products" }, this.showBreadcrumbs && this.breadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.breadcrumbs, hideOnMobile: this.hideOnMobile })), this.isMobile && this.hasActionBlocks() && (h("pes-action-blocks", { actionBlocks: this.appActionBlocks, selectorConfig: this.defaultSelectorConfig })), ((_b = this.businesses) === null || _b === void 0 ? void 0 : _b.length) > 0 && (h("pes-business-lines-se", { linesList: this.businesses, selectBl: this.setActiveBusinessId, topTangesLabel: this.appTopTangesLabel, viewOnLabel: this.viewOnLabel, productsLabel: this.appProductsLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.appMostViewedProductsLabel, learnMoreLabel: this.appLearnMoreLabel, business: businessCategories, isMobile: this.isMobile, activeLine: activeLine, disableBusinessLinesHashRouting: this.disableBusinessLinesHashRouting, changeActiveLine: this.changeActiveLine, isPBS: this.isPBS })), h("main", { class: classnames('all-products__main-content', {
        'all-products__main-content--menu-opened': this.menuCategoryOpened,
      }) }, h("h1", { class: "all-products__header" }, this.breadCrumbsAllProductsLabel), ((_c = this.topCategories) === null || _c === void 0 ? void 0 : _c.length) > 0 && (h("section", { class: classnames('all-products__section', {
        'all-products__section--inactive': !isTopCategoriesActive,
      }) }, h("pes-top-categories", { class: "all-products__top-categories", isActive: isTopCategoriesActive, list: this.topCategories, actionBlocks: this.appActionBlocks, viewOnLabel: this.viewOnLabel, cardCountLabel: this.appRangesLabel, isMobile: this.isMobile, selectorConfig: this.defaultSelectorConfig, hideDownloadCenterBanner: this.hideDownloadCenterBanner, hideMasterRangesBanner: this.hideMasterRangesBanner, isPBS: this.isPBS }))), ((_d = this.businesses) === null || _d === void 0 ? void 0 : _d.length) > 0
      && ((_e = this.businesses) === null || _e === void 0 ? void 0 : _e.map((currentBusiness) => {
        var _a;
        const isActive = this.activeBusinessId === (currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.id) && !this.isMobile;
        return (h("section", { key: (_a = currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.id) !== null && _a !== void 0 ? _a : '', class: classnames('all-products__section', {
            'all-products__section--inactive': !isActive,
          }) }, h("div", { class: "all-products__section-title-wrapper" }, this.renderTitle(currentBusiness)), h("pes-menu-category", { class: "all-products__menu-category", topTangesLabel: this.appTopTangesLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.appMostViewedProductsLabel, menuList: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.categories, business: businessCategories, isMobile: this.isMobile, commerceConnectorSettings: this.commerceConnectorSettings, isPBS: this.isPBS, host: this.host }), h("pes-top-runners", { class: "all-products__top-runners", isActive: isActive, list: currentBusiness === null || currentBusiness === void 0 ? void 0 : currentBusiness.toprunners, viewOnLabel: this.viewOnLabel, productsLabel: this.appProductsLabel, isMobile: this.isMobile })));
      })))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "activeBusinessId": ["activeBusinessIdWatcher"]
  }; }
};
AllProducts.style = allProductsCss;

export { AllProducts as pes_all_products };
